import styled from 'styled-components';

import { fonts, Link, StandardSpinner, StyledFlex } from '@dreryk/react-components';

import { SPINNER_GRADIENT_ID } from '../icons/SpinnerGradientDefs';

export const StyledStandardSpinner = styled(StandardSpinner)`
   --loader-color: url(#${SPINNER_GRADIENT_ID});

   svg {
      height: 38px;
      width: 38px;
   }
`;

StyledStandardSpinner.displayName = 'StyledStandardSpinner';

export const StyledCollapsedSpinnerIcon = styled(StyledFlex)`
   width: 38px;
   height: 38px;
   border-radius: 50%;
   background-color: ${(props) => props.theme.backgroundBody};
`;

StyledCollapsedSpinnerIcon.displayName = 'StyledCollapsedSpinnerIcon';

export const StyledLink = styled(Link)`
   font-weight: ${fonts.fontWeightBold};
`;

StyledLink.displayName = 'StyledLink';
